module.exports = __webpack_public_path__ + "fonts/TTMarxiana-Antiqua.9fff6821.woff";